import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'

export default {
    name: '館藏資源',
    type: 'group',
    fields: [].concat(
        Basic('collection'),
    )
}

  